import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

export function TearExpansionTemplate({
    data, tipos, oleos, listaFitas, listaRodas,
    verificarStatusOleo, verificarStatusFitaRoda,
    handleEdit, handleDelete,
}) {
    const estiloStatus = (status) => {
        if (status === 'vencido') return { backgroundColor: '#ffcdd2', color: '#c63737', fontWeight: 'bold' };
        if (status === 'alerta')  return { backgroundColor: '#fcffcd', color: '#b59f00', fontWeight: 'bold' };
        return { backgroundColor: 'transparent', color: 'inherit', fontWeight: 'normal' };
    };

    return (
        <div>
            <Accordion multiple>
                {tipos.map((item) => {
                    const filtered = data.historico
                        ? data.historico.filter(e => e.manutencao_tipo_id === item.id)
                        : [];

                    let iconeAviso = null;
                    let classeAba  = "";

                    const calcIcone = (temVencido, temAlerta, tituloV, tituloA) => {
                        if (temVencido) {
                            classeAba  = "aba-vencida";
                            iconeAviso = <i className="pi pi-exclamation-circle" style={{ marginLeft: 8 }} title={tituloV} />;
                        } else if (temAlerta) {
                            classeAba  = "aba-alerta";
                            iconeAviso = <i className="pi pi-exclamation-triangle" style={{ marginLeft: 8 }} title={tituloA} />;
                        }
                    };
                    const passadasAtuaisDaMaquina = data.passadas_tear || 0;
                    const ultimoRegistro = filtered.length > 0 
                        ? [...filtered].sort((a, b) => Number(b.id) - Number(a.id))[0] 
                        : null;
                    if (ultimoRegistro) {
                        if (item.id === 10 || item.id === 11) {
                            const status = verificarStatusOleo(ultimoRegistro);
                            calcIcone(
                                status === 'vencido',
                                status === 'alerta',
                                "Atenção: Há óleo vencido!", "Aviso: Óleo próximo do vencimento"
                            );
                        }
                        if (item.id === 24) {
                            const status = verificarStatusFitaRoda(ultimoRegistro, listaFitas, 'fitas_id', passadasAtuaisDaMaquina);
                            calcIcone(
                                status === 'vencido',
                                status === 'alerta',
                                "Atenção: Há fita vencida!", "Aviso: Fita próxima do vencimento"
                            );
                        }
                        if (item.id === 25) {
                            const status = verificarStatusFitaRoda(ultimoRegistro, listaRodas, 'rodas_id', passadasAtuaisDaMaquina);
                            calcIcone(
                                status === 'vencido',
                                status === 'alerta',
                                "Atenção: Há roda vencida!", "Aviso: Roda próxima do vencimento"
                            );
                        }
                    }

                    return (
                        <AccordionTab
                            key={`tipo${item.id}`}
                            headerClassName={classeAba}
                            header={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {item.descricao} {iconeAviso}
                                </div>
                            }
                        >
                            <h5 className="p-m-2">Histórico</h5>
                            <DataTable
                                className="p-m-1"
                                emptyMessage="Nenhum registro lançado até o momento"
                                paginator rows={8} size="small"
                                responsiveLayout="scroll"
                                value={filtered}
                            >
                                <Column header="Tear"   field="tear"   style={{ width: "5%" }} />
                                <Column header="Turma"  field="turma"  style={{ width: "5%" }} />
                                <Column header="Grupo"  field="grupo"  style={{ width: "5%" }} />

                                {/* Óleo */}
                                {(item.id === 10 || item.id === 11) && (
                                    <Column header="Óleo" field="oleo_id" style={{ width: "6%" }}
                                        body={(row) => {
                                            if (!row.oleo_id) return "-";
                                            const o = oleos.find(x => x.id === row.oleo_id);
                                            return o ? o.nome : row.oleo_id;
                                        }}
                                    />
                                )}

                                <Column header="Descrição"  field="descricao" style={{ width: "20%" }} />
                                <Column header="Colaborador" field="colaborador" />
                                <Column header="Data"        field="dataf" />
                                <Column header="Data Lanç."  field="datahora" />

                                {/* Vencimento óleo */}
                                {(item.id === 10 || item.id === 11) && (
                                    <Column header="Vencimento" style={{ width: "8%" }}
                                        body={(row) => {
                                            if (!row.oleo_id) return "-";
                                            const o = oleos.find(x => x.id === row.oleo_id);
                                            if (!o?.validade) return "-";
                                            const venc = new Date(String(row.data).replace(/-/g, "/"));
                                            venc.setFullYear(venc.getFullYear() + parseInt(o.validade));
                                            const fmt = `${String(venc.getDate()).padStart(2,'0')}/${String(venc.getMonth()+1).padStart(2,'0')}/${venc.getFullYear()}`;
                                            const status = verificarStatusOleo(row);
                                            return (
                                                <div style={{ ...estiloStatus(status), padding: '4px 8px', borderRadius: 4, textAlign: 'center' }}>
                                                    {fmt}
                                                </div>
                                            );
                                        }}
                                    />
                                )}

                                {/* Nº Série fita/roda */}
                                {(item.id === 24 || item.id === 25) && (
                                    <Column header="Nº Série" style={{ width: "10%" }}
                                        body={(row) => {
                                            if (item.id === 24) {
                                                if (!row.fitas_id) return "-";
                                                const f = listaFitas.find(x => x.id === row.fitas_id);
                                                return f ? f.nr_serie : row.fitas_id;
                                            }
                                            if (!row.rodas_id) return "-";
                                            const r = listaRodas.find(x => x.id === row.rodas_id);
                                            return r ? r.nr_serie : row.rodas_id;
                                        }}
                                    />
                                )}

                                {/* Passadas na troca */}
                                {(item.id === 24 || item.id === 25) && (
                                    <Column header="Passadas na Troca" field="passadas" style={{ width: "10%" }}
                                        body={(row) => {
                                            if (row.passadas == null) return "-";
                                            const idField = item.id === 24 ? 'fitas_id' : 'rodas_id';
                                            const lista   = item.id === 24 ? listaFitas : listaRodas;
                                            const iv      = lista.find(i => i.id === row[idField]);
                                            if (!iv?.passadas_programadas) return row.passadas;
                                            const passadasNaTroca = row.passadas;
                                            const passadasProgramadas = iv.passadas_programadas;
                                            const passadasAtuais = data.passadas_tear || 0;
                                            const alvoTroca = passadasNaTroca + passadasProgramadas;
                                            const restantes = alvoTroca - passadasAtuais;
                                            const pct = restantes / passadasProgramadas;
                                            const st  = restantes <= 0 ? 'vencido' : pct <= 0.1 ? 'alerta' : 'normal';
                                            return (
                                                <div style={{ ...estiloStatus(st), padding: '4px 8px', borderRadius: 4, textAlign: 'center' }}>
                                                    {passadasNaTroca.toLocaleString('pt-BR')}
                                                    <div style={{ fontSize: '0.75rem', opacity: 0.8 }}>
                                                        {restantes > 0
                                                            ? `Restam: ${restantes.toLocaleString('pt-BR')}`
                                                            : `Excedido: ${Math.abs(restantes).toLocaleString('pt-BR')}`}
                                                    </div>
                                                </div>
                                            );
                                        }}
                                    />
                                )}

                                {/* Passadas programadas */}
                                {(item.id === 24 || item.id === 25) && (
                                    <Column header="Passadas Programadas" style={{ width: "10%" }}
                                        body={(row) => {
                                            const lista = item.id === 24 ? listaFitas : listaRodas;
                                            const idField = item.id === 24 ? 'fitas_id' : 'rodas_id';
                                            const iv = lista.find(i => i.id === row[idField]);
                                            return iv ? iv.passadas_programadas : "-";
                                        }}
                                    />
                                )}

                                {/* Data programada para troca */}
                                {(item.id === 24 || item.id === 25) && (
                                    <Column header="Data Programada p/ Troca" style={{ width: "10%" }}
                                        body={(row) => {
                                            const idField = item.id === 24 ? 'fitas_id' : 'rodas_id';
                                            const lista   = item.id === 24 ? listaFitas : listaRodas;
                                            const iv      = lista.find(i => i.id === row[idField]);
                                            
                                            if (!iv?.validade) return "-";
                                            
                                            const venc = new Date(String(row.data).replace(/-/g, "/"));
                                            venc.setFullYear(venc.getFullYear() + parseInt(iv.validade));
                                            const fmt = `${String(venc.getDate()).padStart(2,'0')}/${String(venc.getMonth()+1).padStart(2,'0')}/${venc.getFullYear()}`;
                                            
                                            const hoje = new Date();
                                            const alerta = new Date(venc);
                                            alerta.setMonth(alerta.getMonth() - 3); 
                                            
                                            let statusData = 'normal';
                                            if (hoje >= venc) {
                                                statusData = 'vencido';
                                            } else if (hoje >= alerta) {
                                                statusData = 'alerta';
                                            }

                                            return (
                                                <div style={{ ...estiloStatus(statusData), padding: '4px 8px', borderRadius: 4, textAlign: 'center' }}>
                                                    {fmt}
                                                </div>
                                            );
                                        }}
                                    />
                                )}

                                <Column header="Usuário" field="usuario" />
                                <Column header="Ações" style={{ width: 110 }}
                                    body={(row) => (
                                        <div>
                                            <Button className="p-m-1 p-button-primary" icon="pi pi-pencil"
                                                onClick={() => handleEdit(row)} title="Editar" />
                                            <Button className="p-m-1 p-button-danger" icon="pi pi-trash"
                                                onClick={() => handleDelete(row)} title="Excluir" />
                                        </div>
                                    )}
                                />
                            </DataTable>
                        </AccordionTab>
                    );
                })}
            </Accordion>
        </div>
    );
}